<div class="card sidebar__common">
    <div class="card-body">
        <div class="flex-container">
            <div class="left-column">
                <ul class="list-item">
                    <li *ngFor="let doc of documents" (click)="showDocumentDetails(doc.id)" class="item" [class.selected]="selectedItemId === doc.id">
                        <div class="font-semibold title">{{ doc.subject }}</div>
                        <div class="text-gray-500 date">{{ doc.created_at }}</div>
                    </li>
                </ul>
            </div>
            <div class="right-column">
                <div *ngIf="selectedDocument">
                    <div class="font-semibold title">{{ selectedDocument.subject }}</div>
                    <div class="text-gray-500 date">{{ selectedDocument.created_at }}</div>
                    <br/>
                    <div class="details-item" [innerHTML]="selectedDocument.content"></div>
                </div>
            </div>
        </div>
    </div>
</div>
